export const leadingZero = (number: number): string => {
  return number < 10 ? `0${number}` : `${number}`
}

export const formatDate = (isoString: string): string => {
  const date = new Date(isoString)
  return `${leadingZero(date.getDate())}/${leadingZero(date.getMonth() + 1)}/${date.getFullYear()}`
}
export const formatDateHour = (isoString: string): string => {
  const date = new Date(isoString)
  return `${leadingZero(date.getDate())}/${leadingZero(date.getMonth() + 1)}/${date.getFullYear()} - ${leadingZero(date.getHours())}:${leadingZero(date.getMinutes())}`
}

export const isSameDay = (d1: Date, d2: Date): boolean => {
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()
}

export const isToday = (date: Date): boolean => {
  return isSameDay(date, new Date())
}

export const isYesterday = (date: Date): boolean => {
  const d = new Date(Date.now() - 24 * 60 * 60 * 1000)
  return isSameDay(d, date)
}

export const toIsoString = (date: Date): string => {
  return `${date.getFullYear()}-${leadingZero(date.getMonth() + 1)}-${leadingZero(date.getDate())}T${leadingZero(date.getHours())}:${leadingZero(date.getMinutes())}:${leadingZero(date.getSeconds())}`
}

export const dateToInputDatetime = (date: Date): string => {
  return `${date.getFullYear()}-${leadingZero(date.getMonth() + 1)}-${leadingZero(date.getDate())}T${leadingZero(date.getHours())}:${leadingZero(date.getMinutes())}`
}
